import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabBar from '../../components/layout/TabBar';

const rechargeAmounts = [50, 100, 200, 500];

const transactions = [
  { id: 1, type: 'charge', amount: 200, date: '2024-01-15', time: '10:30 ص', method: 'بطاقة ائتمانية' },
  { id: 2, type: 'payment', amount: -150, date: '2024-01-14', time: '03:45 م', service: 'تمريض منزلي' },
  { id: 3, type: 'charge', amount: 300, date: '2024-01-12', time: '09:15 ص', method: 'Apple Pay' },
  { id: 4, type: 'payment', amount: -80, date: '2024-01-10', time: '02:20 م', service: 'سباكة' },
  { id: 5, type: 'charge', amount: 100, date: '2024-01-08', time: '11:00 ص', method: 'STC Pay' },
  { id: 6, type: 'payment', amount: -120, date: '2024-01-05', time: '04:30 م', service: 'كهرباء' },
];

export default function Wallet() {
  const navigate = useNavigate();
  const [balance] = useState(450);
  const [showRecharge, setShowRecharge] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState(100);
  const [customAmount, setCustomAmount] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const handleRecharge = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      setShowRecharge(false);
      setCustomAmount('');
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-8 px-6 rounded-b-[30px]">
        <div className="flex items-center gap-3 mb-6 animate-fadeIn">
          <button onClick={() => navigate(-1)} className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          <h1 className="text-xl font-bold text-white">المحفظة</h1>
        </div>

        {/* Balance Card */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20 animate-slideUp">
          <div className="flex items-center justify-between mb-2">
            <span className="text-white/80 text-sm">الرصيد الحالي</span>
            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
              <i className="ri-wallet-3-fill text-white text-xl"></i>
            </div>
          </div>
          <div className="text-4xl font-bold text-white mb-4">{balance} ر.س</div>
          <button
            onClick={() => setShowRecharge(true)}
            className="w-full bg-white text-[#1565C0] py-3 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-white/90 transition-all"
          >
            <i className="ri-add-circle-line text-xl"></i>
            <span>شحن المحفظة</span>
          </button>
        </div>
      </div>

      {/* Transactions */}
      <div className="px-6 mt-6">
        <h3 className="font-bold text-[#212121] mb-4">آخر العمليات</h3>
        
        <div className="space-y-3">
          {transactions.map((transaction, index) => (
            <div
              key={transaction.id}
              className="bg-white rounded-2xl p-4 shadow-md animate-slideUp"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center gap-3">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                  transaction.type === 'charge' 
                    ? 'bg-[#2E7D32]/10' 
                    : 'bg-[#1565C0]/10'
                }`}>
                  <i className={`text-xl ${
                    transaction.type === 'charge'
                      ? 'ri-arrow-down-line text-[#2E7D32]'
                      : 'ri-arrow-up-line text-[#1565C0]'
                  }`}></i>
                </div>
                
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <span className="font-semibold text-[#212121]">
                      {transaction.type === 'charge' ? 'شحن المحفظة' : 'دفع خدمة'}
                    </span>
                    <span className={`font-bold ${
                      transaction.type === 'charge' ? 'text-[#2E7D32]' : 'text-[#1565C0]'
                    }`}>
                      {transaction.amount > 0 ? '+' : ''}{transaction.amount} ر.س
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">
                      {transaction.type === 'charge' ? transaction.method : transaction.service}
                    </span>
                    <span className="text-xs text-gray-400">
                      {transaction.date} • {transaction.time}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Recharge Modal */}
      {showRecharge && (
        <div className="fixed inset-0 bg-black/50 flex items-end justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-t-3xl w-full max-h-[80vh] overflow-y-auto animate-slideUp">
            <div className="sticky top-0 bg-white border-b border-gray-100 p-6 pb-4">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-bold text-[#212121]">شحن المحفظة</h3>
                <button
                  onClick={() => setShowRecharge(false)}
                  className="w-9 h-9 bg-gray-100 rounded-xl flex items-center justify-center"
                >
                  <i className="ri-close-line text-gray-600 text-xl"></i>
                </button>
              </div>
            </div>

            <div className="p-6">
              {/* Quick Amounts */}
              <div className="mb-6">
                <label className="text-sm font-semibold text-[#212121] mb-3 block">اختر المبلغ</label>
                <div className="grid grid-cols-2 gap-3">
                  {rechargeAmounts.map((amount) => (
                    <button
                      key={amount}
                      onClick={() => {
                        setSelectedAmount(amount);
                        setCustomAmount('');
                      }}
                      className={`p-4 rounded-xl font-bold transition-all ${
                        selectedAmount === amount && !customAmount
                          ? 'bg-gradient-to-br from-[#1565C0] to-[#2E7D32] text-white shadow-lg'
                          : 'bg-[#F6F6F6] text-[#212121] hover:bg-gray-200'
                      }`}
                    >
                      {amount} ر.س
                    </button>
                  ))}
                </div>
              </div>

              {/* Custom Amount */}
              <div className="mb-6">
                <label className="text-sm font-semibold text-[#212121] mb-3 block">أو أدخل مبلغ مخصص</label>
                <div className="relative">
                  <input
                    type="number"
                    value={customAmount}
                    onChange={(e) => {
                      setCustomAmount(e.target.value);
                      setSelectedAmount(0);
                    }}
                    placeholder="0"
                    className="w-full bg-[#F6F6F6] rounded-xl p-4 pr-12 outline-none text-lg font-semibold text-[#212121]"
                  />
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-semibold">
                    ر.س
                  </span>
                </div>
              </div>

              {/* Payment Methods */}
              <div className="mb-6">
                <label className="text-sm font-semibold text-[#212121] mb-3 block">طريقة الدفع</label>
                <div className="space-y-2">
                  {[
                    { id: 'card', name: 'بطاقة ائتمانية', icon: 'ri-bank-card-line' },
                    { id: 'apple', name: 'Apple Pay', icon: 'ri-apple-line' },
                    { id: 'stc', name: 'STC Pay', icon: 'ri-smartphone-line' },
                  ].map((method) => (
                    <button
                      key={method.id}
                      className="w-full flex items-center gap-3 p-4 bg-[#F6F6F6] rounded-xl hover:bg-gray-200 transition-all"
                    >
                      <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                        <i className={`${method.icon} text-gray-600 text-xl`}></i>
                      </div>
                      <span className="flex-1 text-right font-semibold text-[#212121]">{method.name}</span>
                      <i className="ri-arrow-left-s-line text-gray-400"></i>
                    </button>
                  ))}
                </div>
              </div>

              {/* Confirm Button */}
              <button
                onClick={handleRecharge}
                disabled={!customAmount && !selectedAmount}
                className="w-full bg-gradient-to-l from-[#1565C0] to-[#2E7D32] text-white py-4 rounded-xl font-bold shadow-lg disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-xl transition-all active:scale-[0.98]"
              >
                تأكيد الشحن
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccess && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center px-6 z-50 animate-fadeIn">
          <div className="bg-white rounded-2xl p-8 text-center animate-slideUp">
            <div className="w-20 h-20 bg-[#2E7D32] rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse-soft">
              <i className="ri-check-line text-white text-4xl"></i>
            </div>
            <h3 className="text-xl font-bold text-[#212121] mb-2">تم الشحن بنجاح!</h3>
            <p className="text-gray-600">تم إضافة المبلغ إلى محفظتك</p>
          </div>
        </div>
      )}

      <TabBar />
    </div>
  );
}
